import * as mttTypes from '@/store/mutationTypes'

const state = {
  chpDevSelect: null,
  ewhDevSelect: null,
  groupInfos: [],
  devInfos: []
}

const getters = {
  curSelChpDevDid: state => {
    return state.chpDevSelect !== null ? state.chpDevSelect.deviceid : -1
  },
  curSelEwhDevDid: state => {
    return state.ewhDevSelect !== null ? state.ewhDevSelect.deviceid : -1
  }
}

const mutations = {
  [mttTypes.SET_CHP_DEV_SELECT] (state, devSelect) {
    state.chpDevSelect = devSelect
  },
  [mttTypes.SET_EWH_DEV_SELECT] (state, devSelect) {
    state.ewhDevSelect = devSelect
  }
}

const CHP_DEV_TYPE = 1
const EWH_DEV_TYPE = 2

const actions = {
  setDevSelect ({commit, state}, {device, devType}) {
    if (devType === CHP_DEV_TYPE) commit(mttTypes.SET_CHP_DEV_SELECT, device)
    else if (devType === EWH_DEV_TYPE) commit(mttTypes.SET_EWH_DEV_SELECT, device)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/devSelect.js